import type { CheckedOption } from '@/api/trade-capture/option/response.model.ts';
import { mapCheckOption, type OptionTcResponse } from '@/api/trade-capture/option/response.ts';
import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import type { FxOption } from '@/store/option/state.ts';

export interface CreateStripParams {
  tileId: string;

  idVersion: number;
  sessionId: string;

  frequency: 'Monthly' | 'Weekly' | 'Daily';
  startDate: string;

  iterations?: number;
  endDate?: string;

  option?: FxOption;
}

export const createStrip = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<OptionTcResponse, CreateStripParams>({
    query: (params) => {
      const { tileId: _tileId, sessionId, idVersion, ...body } = params;
      return {
        url: `/tradeCapture/FxOptionMultileg/${sessionId}/stripping`,
        method: 'POST',
        body: {
          idVersion: idVersion + 1,
          ...body,
        },
      };
    },
    transformResponse(response: CheckedOption, _meta, params) {
      const tileId = params.tileId;
      return mapCheckOption(response, tileId, params.sessionId, params.option);
    },
  });
};
